import { GridDomLayout } from '../enums/GridDomLayout';

export class GridLayoutService {
  static getDomLayout(isFixedHeight: boolean): GridDomLayout {
    return isFixedHeight ? GridDomLayout.Normal : GridDomLayout.AutoHeight;
  }
}
